import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.restorePresetState()
  }

  applyPreset(event) {
    const btn = event.currentTarget
    const dateFromValue = btn.dataset.dateRangeFrom
    const dateToValue = btn.dataset.dateRangeTo

    this.element.querySelector("[name='date_from']").value = dateFromValue
    const dateToField = this.element.querySelector("[name='date_to']") || this.element.querySelector("#heatmap_date_to")
    dateToField.value = dateToValue

    // Auto-update comparison dates based on same period length
    const [fromYear, fromMonth, fromDay] = dateFromValue.split('-').map(Number)
    const [toYear, toMonth, toDay] = dateToValue.split('-').map(Number)

    const dateFrom = new Date(fromYear, fromMonth - 1, fromDay)
    const dateTo = new Date(toYear, toMonth - 1, toDay)
    const periodLength = Math.floor((dateTo - dateFrom) / (1000 * 60 * 60 * 24)) + 1

    const compareDateTo = new Date(fromYear, fromMonth - 1, fromDay)
    compareDateTo.setDate(compareDateTo.getDate() - 1)

    const compareDateFrom = new Date(fromYear, fromMonth - 1, fromDay)
    compareDateFrom.setDate(compareDateFrom.getDate() - periodLength)

    const compareFromField = this.element.querySelector("[name='compare_date_from']")
    const compareToField = this.element.querySelector("[name='compare_date_to']")

    if (compareFromField && compareToField) {
      compareFromField.value = this.formatDate(compareDateFrom)
      compareToField.value = this.formatDate(compareDateTo)
    }

    this.updateButtonStates(dateFromValue, dateToValue)

    const params = new URLSearchParams()
    params.set('date_from', dateFromValue)
    params.set('date_to', dateToValue)
    params.set('compare_date_from', this.formatDate(compareDateFrom))
    params.set('compare_date_to', this.formatDate(compareDateTo))

    window.location.href = `${window.location.pathname}?${params.toString()}`
  }

  restorePresetState() {
    const dateFromField = this.element.querySelector("[name='date_from']")
    const dateToField = this.element.querySelector("[name='date_to']") || this.element.querySelector("#heatmap_date_to")

    if (dateFromField && dateToField && dateFromField.value && dateToField.value) {
      this.updateButtonStates(dateFromField.value, dateToField.value)
    }
  }

  updateButtonStates(dateFromValue, dateToValue) {
    const buttons = this.element.querySelectorAll('[data-date-range-from]')

    buttons.forEach(btn => {
      const isMatch = btn.dataset.dateRangeFrom === dateFromValue && btn.dataset.dateRangeTo === dateToValue

      if (isMatch) {
        btn.classList.remove('btn-outline-secondary')
        btn.classList.add('btn-primary')
      } else {
        btn.classList.remove('btn-primary')
        btn.classList.add('btn-outline-secondary')
      }
    })
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  submit() {
    const dateFromField = this.element.querySelector("[name='date_from']")
    const dateToField = this.element.querySelector("[name='date_to']")
    const compareDateFromField = this.element.querySelector("[name='compare_date_from']")
    const compareDateToField = this.element.querySelector("[name='compare_date_to']")

    const params = new URLSearchParams()
    if (dateFromField?.value) params.set('date_from', dateFromField.value)
    if (dateToField?.value) params.set('date_to', dateToField.value)
    if (compareDateFromField?.value) params.set('compare_date_from', compareDateFromField.value)
    if (compareDateToField?.value) params.set('compare_date_to', compareDateToField.value)

    window.location.href = `${window.location.pathname}?${params.toString()}`
  }

  syncDateTo(event) {
    const dateToField = this.element.querySelector("#heatmap_date_to")
    dateToField.value = event.target.value

    const dateFromField = this.element.querySelector("[name='date_from']")

    const params = new URLSearchParams()
    if (dateFromField?.value) params.set('date_from', dateFromField.value)
    if (dateToField?.value) params.set('date_to', dateToField.value)

    window.location.href = `${window.location.pathname}?${params.toString()}`
  }

}
